// extracted by extract-css-chunks-webpack-plugin
module.exports = {"holidayMessageContainer":"x819K","holidayMessageIcon":"C2u5B","freePickUpMsg":"kAMVb"};